import { render, staticRenderFns } from "./MemberRegisterPage.vue?vue&type=template&id=5d9e7b85"
import script from "./MemberRegisterPage.vue?vue&type=script&lang=js"
export * from "./MemberRegisterPage.vue?vue&type=script&lang=js"
import style0 from "./MemberRegisterPage.vue?vue&type=style&index=0&id=5d9e7b85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports